import { activityLogService } from '../_services';
import { router } from '../router/index';
import { apigClient } from '@/shared/api';

const actions = {
    create( bodyParams ) {
        activityLogService.create(bodyParams).then(
            data => {
                return data;
            }
        ).catch((error) => {
            console.log(error);
            return error;
        }
        );    
    },
    get( { commit }, { object_id } ){
        activityLogService.get(object_id).then(
            data => {
                // data = JSON.parse(data);
                console.log("Data module ::: " + data )
                return data;
            }
        ).catch((error) => {
            console.log(error);
            return error;
        }
        );  
    },
};

const mutations = {
};

export const activityLog = {
    namespaced: true,
    actions,
    mutations
};